<template>
    <div>
        <div>
            <a :href="'/orders/' + order._id" target="_blank"><h4>{{ order._source.name }}
                (#{{ order._id }}) [{{order._source.account_name}}]</h4></a>
        </div>
        <div class="subtitle">
            {{ order._source.created_at }}
        </div>
        <div>
            <div>Matches: {{ this.matchedFields }}</div>
            <div><a v-if="this.matchedFields !== 'order_id'" @click.prevent="show = !show">{{this.showMatchMessage}}</a></div>
        </div>
        <transition name="fade">
            <div v-if="show">
                <div v-bind:key="key" v-for="(value, key) in order.highlight" class="result-matches">
                    <div>{{ humanize(key) }}:
                        <li v-bind:key="v" v-for="v in value" v-html="v"></li>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>

/**
 * Wraps around AcclaroElasticSearchInput and provide
 * results in a list.
 */

import moment from "moment";

export default {
    name: "AdminOrderSearchResult",
    props: ['order'],
    data: function () {
        return {
            show: false,
        }
    },
    computed: {
        matchedFields() {
            if(!this.order.highlight){
                // if match and no highlight, match is by ID
                return 'Order ID'
            }
            return Object.keys(this.order.highlight).map(i => this.humanize(i)).join(', ')
        },
        showMatchMessage(){
            return this.show ? 'hide details' : 'show details';
        }
    },
    methods: {
        moment,
        humanize(str) {
            let i, frags = str.split('_');
            for (i=0; i<frags.length; i++) {
                frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
            }
            return frags.join(' ');
        }
    },
};
</script>
<style scoped>
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
    opacity: 0;
}

.result-matches {
    padding: 13px;
    margin: 5px;
    border: 1px solid lightgrey;
    border-radius: 4px
}
</style>

